module.exports = __webpack_public_path__ + "static/logo-f883f8085c7ab3810ea904f12d7f1a20.png";